import handler from "api/handler";

const prefix = "/userAdmin/jobs"

const methods = {
  getAllJobs: (params) => handler({ method: 'get', url: `${prefix}/fetchAll`, params }),
};

export default methods;